import { render, staticRenderFns } from "./ATemplateContratoDiplo.vue?vue&type=template&id=23a77a11"
import script from "./ATemplateContratoDiplo.vue?vue&type=script&lang=js"
export * from "./ATemplateContratoDiplo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports